import {
  Indicator,
  Toast
} from "mint-ui";

/**
 * 存储localStorage
 */
const setStorage = (name, content) => {
  if (!name) return;
  if (typeof content !== "string") {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
const getStorage = name => {
  if (!name) return;
  return window.localStorage.getItem(name);
};

/**
 * 删除localStorage
 */
const rmStorage = name => {
  if (!name) return;
  window.localStorage.removeItem(name);
};

const setSkin = name => {
  console.log(document.head)
  let header = document.head
  let css = document.createElement('link')
  css.setAttribute("rel", "stylesheet")
  css.setAttribute("type", "text/css")
  css.setAttribute("href", "../skin/skin1.css")
  header.appendChild(css)
}

const historySearch = {
  add(searchString) {
    const maxRecordNum = 10;
    let historySearchData = this.getHistorySearchData();

    if (!historySearchData) {
      historySearchData = [];
      historySearchData.push(searchString);
    } else {
      const currentListLength = historySearchData.length;
      const searchStringIndex = historySearchData.indexOf(searchString);

      if (searchStringIndex != -1) {
        historySearchData.splice(searchStringIndex, 1);
        historySearchData.unshift(searchString);
      } else {
        if (currentListLength >= maxRecordNum) {
          historySearchData.splice(maxRecordNum - 1, 1);
        }
        historySearchData.unshift(searchString);
      }
    }
    setStorage("historySearch", JSON.stringify(historySearchData));
  },
  getHistorySearchData() {
    return JSON.parse(getStorage("historySearch"));
  },

  delete() {
    rmStorage("historySearch");
  }
};

const formatNumber = (num, digits) => {
  return parseFloat(num).toFixed(digits);
};
//get bg color choices

const parseBgColor = bgArr10 => {
  let bgArr16 = bgArr10.map(color10 => {
    const {
      start_color,
      color_name,
      enc_color
    } = color10;
    let color16 = {
      endColor: enc_color.toString(16).padStart(6, 0),
      name: color_name,
      startColor: start_color.toString(16).padStart(6, 0)
    };
    return color16;
  });
  return bgArr16;
};

//caculate file size (KB) range, given max and min bit size .
function caculateSize(minSize_b, maxSize_b) {
  let maxSize = Math.floor(maxSize_b / 1024);
  let minSize = Math.floor(minSize_b / 1024);
  let size;
  if (maxSize && minSize) {
    size = `${minSize}~${maxSize}KB`;
  } else if (maxSize) {
    size = `不大于${maxSize}KB`;
  } else {
    size = `不小于${minSize}KB`;
  }

  return size;
}

function toBase64(file, callback) {
  var fileReader = new FileReader();

  fileReader.addEventListener(
    "load",
    function () {
      var base64_origin = fileReader.result;
      var base64_remove_head = base64_origin.split(",")[1];
      callback({
        base64_origin: base64_origin,
        base64_remove_head: base64_remove_head
      });
    },
    false
  );

  if (file) {
    fileReader.readAsDataURL(file);
  }
}

//类数组转化为数组
function argtoArray(arg) {
  return [...arg];
}
//验证并提示错误
function validate(msg, fn) {
  return function () {
    let args = argtoArray(arguments);
    let bol = fn.apply(undefined, args)
    return {
      msg: msg,
      success: bol
    }
  }
}
function runValidate() {
  let validateArr = argtoArray(arguments);
  return function () {
    let res = {
      success: true,
      msg: ''
    }
    let arg = argtoArray(arguments);
    validateArr.some(fn => {
      let fnObj = fn.apply(undefined, arg);
      if (fnObj.success) {
        res = {
          success: false,
          msg: fnObj.msg
        }
        return true;
      }
    });
    return res;
  }
}
function isEmpty(val) {
  return val == null || val === '';
}
function wrongEmail(val) {
  let reg = new RegExp('^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*\\.[a-zA-Z0-9]{2,6}$');
  return !reg.test(val);
}
//验证邮箱
const emailReg = runValidate(
  validate('请输入邮箱', isEmpty),
  validate('请输入正确的邮箱地址', wrongEmail)
)

//根据平台和是否是合并支付得类型名（策略模式）
function getPayType(platform, type) {
  let obj = {
    'wechatsingle': 'wechat-pay-params',
    'wechatmerge': 'wechat-pay-merge',
    'alipaysingle': 'alipay-params',
    'alipaymerge': 'alipay-merge',
    'baidusingle': 'baidu-pay-params',
    'baidumerge': 'baidu-pay-merge'
  }
  let key = `${platform}${type}`;
  return obj[key];
}

export {
  getPayType,
  emailReg,
  setStorage,
  getStorage,
  rmStorage,
  historySearch,
  formatNumber,
  parseBgColor,
  caculateSize,
  toBase64,
  setSkin
}

// 冲印模块
export const calcMul = (arg1, arg2) => {
  let m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString();
  try {
    m += s1.split(".")[1].length
  } catch (e) { }
  try {
    m += s2.split(".")[1].length
  } catch (e) { }
  return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
};

export const calcAdd = (arg1, arg2) => {
  let r1, r2, m, n;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2)); //last modify by deeka //动态控制精度长度
  n = (r1 >= r2) ? r1 : r2;
  return ((arg1 * m + arg2 * m) / m).toFixed(n);
};

export const calcSub = (arg1, arg2) => {
  let r1, r2, m, n;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2)); //last modify by deeka //动态控制精度长度
  n = (r1 >= r2) ? r1 : r2;
  return ((arg1 * m - arg2 * m) / m).toFixed(n);
};

function dataURLToBlob(dataurl){
  var arr = dataurl.split(',');
  var mime = arr[0].match(/:(.*?);/)[1];
  var bstr = atob(arr[1]);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);
  while(n--){
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {type:mime});
}


const createPrintCache = {}
export const createPrint = (obj, colors, txt) => {
  console.log("lailema:::",obj,colors,txt)
  let keyname = obj.image_url+colors
  if(createPrintCache[keyname]){
    console.log("拿缓存啦")
    return Promise.resolve(createPrintCache[keyname])
  }
  //obj-{wm_url:'2.png',paper_size:[1795,1205],is_rotate:false,img_size:[354,472],coordinate:[{left:145,top:115}]}
  //colors-['rgb(100, 105, 124)','rgb(165, 170, 189)']
  //txt-"画布添加的文字描述"
  let { image_url:wm_url, print_size:paper_size, image_size:img_size, coordinates:coordinate, is_rotate } = obj
  let haha = document.createElement('CANVAS')
  haha.style.display = 'none'
  haha.width = paper_size[0]
  haha.height = paper_size[1]
  document.getElementById("app").appendChild(haha)
  let cot = haha.getContext('2d')
  cot.fillStyle = "#ffffff"
  cot.fillRect(0,0,paper_size[0],paper_size[1])
  drawlines(cot, paper_size, img_size, coordinate, is_rotate, 'black')
  //图片与图片之间需要的间隔
  drawIntervalRect(cot, 80, img_size, coordinate, is_rotate, '#ffffff')
  drawtxt(cot, txt, paper_size)
  return drawImage(cot, wm_url, img_size, coordinate, is_rotate, colors).then(res => {
    let url = URL.createObjectURL(dataURLToBlob(haha.toDataURL()))
    createPrintCache[keyname]=url
    document.getElementById("app").removeChild(haha)
    return url
  })
  function drawlines(cot, paper_size, img_size, coordinate, is_rotate, color) {
    cot.strokeStyle = color;
    coordinate.forEach(item => {
      //8个方向划线
      //左上角横
      drawline(cot, {
        x: item.left,
        y: item.top
      }, {
        x: 0,
        y: item.top
      })
      //左上角竖
      drawline(cot, {
        x: item.left,
        y: item.top
      }, {
        x: item.left,
        y: 0
      })
      //右上角横
      drawline(cot, {
        ...!is_rotate && { x: item.left + img_size[0] },
        ...is_rotate && { x: item.left + img_size[1] },
        y: item.top
      }, {
        x: paper_size[0],
        y: item.top
      })
      //右上角竖
      drawline(cot, {
        ...!is_rotate && { x: item.left + img_size[0] },
        ...is_rotate && { x: item.left + img_size[1] },
        y: item.top
      }, {
        ...!is_rotate && { x: item.left + img_size[0] },
        ...is_rotate && { x: item.left + img_size[1] },
        y: 0
      })
      // 左下角横
      drawline(cot, {
        x: item.left,
        ...!is_rotate && { y: item.top + img_size[1] },
        ...is_rotate && { y: item.top + img_size[0] },
      }, {
        x: 0,
        ...!is_rotate && { y: item.top + img_size[1] },
        ...is_rotate && { y: item.top + img_size[0] },
      })
      //左下角竖
      drawline(cot, {
        x: item.left,
        ...!is_rotate && { y: item.top + img_size[1] },
        ...is_rotate && { y: item.top + img_size[0] },
      }, {
        x: item.left,
        y: paper_size[1]
      })
      //右下角横
      drawline(cot, {
        ...!is_rotate && { x: item.left + img_size[0], y: item.top + img_size[1] },
        ...is_rotate && { x: item.left + img_size[1], y: item.top + img_size[0] },
      }, {
        x: paper_size[0],
        ...!is_rotate && { y: item.top + img_size[1] },
        ...is_rotate && { y: item.top + img_size[0] },
      })
      //右下角竖
      drawline(cot, {
        ...!is_rotate && { x: item.left + img_size[0], y: item.top + img_size[1] },
        ...is_rotate && { x: item.left + img_size[1], y: item.top + img_size[0] },
      }, {
        ...!is_rotate && { x: item.left + img_size[0] },
        ...is_rotate && { x: item.left + img_size[1] },
        y: paper_size[1]
      })
    })
    //清除图片之间的连线
    let len = coordinate.length
    cot.fillStyle="#ffffff"
    cot.fillRect(coordinate[0].left - 2, coordinate[0].top - 2, coordinate[len - 1].left - coordinate[0].left + img_size[is_rotate ? 1 : 0] + 4, coordinate[len - 1].top - coordinate[0].top + img_size[is_rotate ? 0 : 1] + 4)
  }
  function drawline(cot, start, end) {
    cot.beginPath();
    cot.moveTo(start.x, start.y);
    cot.lineTo(end.x, end.y);
    cot.stroke();
  }
  function drawtxt(cot, txt, pagesize) {
    console.log(pagesize)
    cot.beginPath()
    cot.fillStyle = "black"
    cot.font = "50px Arial";
    cot.textAlign = "right";
    cot.fillText(txt, pagesize[0] - 20, pagesize[1] - 20)
  }
  function drawIntervalRect(cot, interval, img_size, coordinate, is_rotate, bg) {
    cot.beginPath();
    cot.fillStyle = bg;
    for (let i = 0, len = coordinate.length; i < len; i++) {
      let item = coordinate[i]
      if (is_rotate) {
        cot.save()
        cot.translate(item.left - interval / 2, item.top - interval / 2)
        cot.rotate(-90 * Math.PI / 180)
        cot.translate(-item.left - interval / 2 - img_size[0], -item.top + interval / 2)
      }
      cot.fillRect(item.left - interval / 2, item.top - interval / 2, img_size[0] + interval, img_size[1] + interval)
      let nextitem = coordinate[i + 1]
      if (is_rotate) {
        cot.restore()
      }
      // if(nextitem&&item.y===nextitem.y){
      // 	if(is_rotate){
      // 		cot.clearRect(item.x+img_size[1],item.y-5,nextitem.x-item.x,10)
      // 		cot.clearRect(item.x+img_size[1],item.y+img_size[0]-5,nextitem.x-item.x,10)
      // 	}else{
      // 		cot.clearRect(item.x+img_size[0],item.y-5,nextitem.x-item.x,10)
      // 		cot.clearRect(item.x+img_size[0],item.y+img_size[1]-5,nextitem.x-item.x,10)
      // 	}
      // }
    }
  }
  function drawImage(cot, img, imgsixe, coordinate, is_rotate, colors) {
    let bg = colors[0] || '#ff0000'
    let color2 = colors[1] || '#ff0000'
    return new Promise((resolve, reject) => {
      var imgobj = new Image()
      imgobj.crossOrigin="anonymous"
      imgobj.src = img
      imgobj.onload = function () {
        coordinate.forEach(item => {
          if (is_rotate) {
            cot.save()
            cot.translate(item.left, item.top)
            cot.rotate(-90 * Math.PI / 180)
            cot.translate(-item.left - imgsixe[0], -item.top)
          }
          var my_gradient = cot.createLinearGradient(item.left, item.top, item.left, item.top + imgsixe[1]);
          console.log("bgbgbg:::",bg,color2);
          my_gradient.addColorStop(0, bg);
          my_gradient.addColorStop(1, color2);
          cot.fillStyle = my_gradient
          cot.fillRect(item.left, item.top, imgsixe[0], imgsixe[1])
          cot.drawImage(imgobj, item.left, item.top, imgsixe[0], imgsixe[1])
          if (is_rotate) {
            cot.restore()
          }
        })
        resolve('')
      }
      imgobj.onerror = function(){
        reject('图片加载失败')
      }
    })
  }
}

export function dataURLtoFile(dataurl, filename) { //将base64转换为文件
    if(dataurl.indexOf('data:image')!=0){
      dataurl='data:image/jpeg;base64,'+dataurl
    }
    dataurl = dataurl.replace(/\r|\n/g,'').replace('data:image/jgp','data:image/jpeg')
    var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
    while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {
    type: mime
  });
}

export const getDateAfterNDay = (today, n) => {
  // must use copied obj ,otherwise will modify origin date object
  const copiedDate = new Date(today.getTime());
  const dayOfToday = copiedDate.getDate();
  // const monthOfToday = today.getMonth() + 1;
  const timeStampAfterNDay = copiedDate.setDate(dayOfToday + n);
  const resultDate = new Date(timeStampAfterNDay);

  return `${resultDate.getMonth() + 1}月${resultDate.getDate()}日`;
};

export const getTrackKey = (appid) => {
  let obj = {
    "wxc22626c10c142ab9":"b699b94c"
  }
  return obj[appid] || ''
}

export const getPlatform = (platform) =>{
  let obj = {
    "wechat":"wechat_applet",
    "alipay":"alipay_applet",
    "baidu":"bd_applet",
    "ByteDance":"byte_applet"
  }
  return obj[platform] || 'web'
}

export const parseUrl = (url,params=[]) =>{
  url=url.split('?')[1] || ''
  let obj = url.split('&').reduce((o,item)=>{
    let [k,v] = item.split('=')
    if(params.indexOf(k)>=0){
      o[k]=v
    }
    return o
  },{})
  return obj
}

export const agreement = (appid) => {
  let obj = {
    "2018011801952052": {
      compony: '无锡乐骐科技有限公司',
      abridge: "乐骐科技",
      name: '最美证件照',
      pro: '支付宝小程序'
    },
    "2018061560377443": {
      compony: '无锡乐骐科技有限公司',
      abridge: "乐骐科技",
      name: '智能证件照',
      pro: '支付宝小程序'
    },
    "2021001195600356": {
      compony: '无锡乐骐科技有限公司',
      abridge: "乐骐科技",
      name: '智能证件照',
      pro: '支付宝小程序'
    },
    "wxf819edfc37816c77": {
      compony: '无锡乐骐科技有限公司',
      abridge: "乐骐科技",
      name: '最美证件照制作',
      pro: '微信小程序'
    },
    "wx5dd0637d33d1b00d": {
      compony: '无锡乐骐科技有限公司',
      abridge: "乐骐科技",
      name: '证件照拍摄',
      pro: '微信小程序'
    },
    "wx303e650f9b81ba59": {
      compony: '无锡乐骐科技有限公司',
      abridge: "乐骐科技",
      name: '证件照制作',
      pro: '微信小程序'
    },
    "wx4c8ee7411e5d3240": {
      compony: '无锡乐骐科技有限公司',
      abridge: "乐骐科技",
      name: '合格证件照相机',
      pro: '微信小程序'
    },
    "wx0fc615669fe3cc30": {
      compony: '无锡乐骐科技有限公司',
      abridge: "乐骐科技",
      name: '合格证件照拍摄软件',
      pro: '微信小程序'
    },
    "wx5b23d9445e629d0b": {
      compony: '无锡乐骐科技有限公司',
      abridge: "乐骐科技",
      name: '合格证件照制作',
      pro: '微信小程序'
    },
    "wx95d51f63d278a03a": {
      compony: '无锡乐骐科技有限公司',
      abridge: "乐骐科技",
      name: '二寸证件照相机',
      pro: '微信小程序'
    },
    "wxca403f1da308d766": {
      compony: '无锡乐骐科技有限公司',
      abridge: "乐骐科技",
      name: '二寸证件照拍摄',
      pro: '微信小程序'
    },
    "wxe6543245180b7d0b": {
      compony: '上海莫能臣智能科技有限公司',
      abridge: '莫能臣科技',
      name: '二寸证件照',
      pro: '微信小程序'
    },
    "wx9f0c5739eec4087d": {
      compony: '无锡乐骐科技有限公司',
      abridge: "乐骐科技",
      name: '智能证件照拍摄',
      pro: '微信小程序'
    },
    "wx45da3d2309ba8dc1": {
      compony: '无锡乐骐科技有限公司',
      abridge: "乐骐科技",
      name: '智能证件照制作',
      pro: '微信小程序'
    },
    "wx5dc88fc55693f38f": {
      compony: '上海莫能臣智能科技有限公司',
      abridge: '莫能臣科技',
      name: '专业证件照相机',
      pro: '微信小程序'
    },
    "wx0fc0cff89371ea8d": {
      compony: '上海莫能臣智能科技有限公司',
      abridge: '莫能臣科技',
      name: '专业证件照拍摄',
      pro: '微信小程序'
    },
    "wxe7cc626c5df3b8d4": {
      compony: '上海莫能臣智能科技有限公司',
      abridge: '莫能臣科技',
      name: '半身证件照制作',
      pro: '微信小程序'
    },
    "wxd7cc9be3acc4e033": {
      compony: '上海莫能臣智能科技有限公司',
      abridge: '莫能臣科技',
      name: '二寸证件照制作',
      pro: '微信小程序'
    },
    "wx4af1c4368f35995d": {
      compony: '上海莫能臣智能科技有限公司',
      abridge: '莫能臣科技',
      name: '一寸证件照相机',
      pro: '微信小程序'
    },
    "wx91d39bf25f1d9d52": {
      compony: '上海莫能臣智能科技有限公司',
      abridge: '莫能臣科技',
      name: '半身证件照',
      pro: '微信小程序'
    },
    "wxbe5fb38d07685d76": {
      compony: '上海莫能臣智能科技有限公司',
      abridge: '莫能臣科技',
      name: '智能证件照相机',
      pro: '微信小程序'
    },
    "wx507a3308b839e8fe": {
      compony: '无锡乐骐科技有限公司',
      abridge: "乐骐科技",
      name: '智能证件照App',
      pro: '微信小程序'
    },
    "wx4a53367365194b99": {
      compony: '无锡乐骐科技有限公司',
      abridge: "乐骐科技",
      name: '证件照软件',
      pro: '微信小程序'
    },
    "wxb6c9cbf839ed8be4": {
      compony: '无锡乐骐科技有限公司',
      abridge: "乐骐科技",
      name: '证件照相机',
      pro: '微信小程序'
    },
    "wxc22626c10c142ab9": {
      compony: '无锡乐骐科技有限公司',
      abridge: "乐骐科技",
      name: '一寸证件照制作',
      pro: '微信小程序'
    },
    "wxae06cebe2e0f9042": {
      compony: '无锡乐骐科技有限公司',
      abridge: "乐骐科技",
      name: '证件照研究院',
      pro: '微信小程序'
    },
    "wx298c5a528a078c54": {
      compony: '无锡乐骐科技有限公司',
      abridge: "乐骐科技",
      name: '证件照研究院',
      pro: '微信小程序'
    },
    "wxe51abad3f94a5cb1": {
      compony: '无锡乐骐科技有限公司',
      abridge: "乐骐科技",
      name: '职业形象照',
      pro: '微信小程序'
    },
    "wxb4936716b42672aa": {
      compony: '无锡乐骐科技有限公司',
      abridge: "乐骐科技",
      name: '证件照换底色软件',
      pro: '微信小程序'
    },
    "wx54c30bcddda58a88": {
      compony: '无锡乐骐科技有限公司',
      abridge: "乐骐科技",
      name: '证件照裁剪',
      pro: '微信小程序'
    },
    "2019091667449122": {
      compony: '无锡乐骐科技有限公司',
      abridge: "乐骐科技",
      name: '职业形象照',
      pro: '支付宝小程序'
    },
    "2019092767826546": {
      compony: '无锡乐骐科技有限公司',
      abridge: "乐骐科技",
      name: '证件照换底色',
      pro: '支付宝小程序'
    },
    "2019092767845384": {
      compony: '无锡乐骐科技有限公司',
      abridge: "乐骐科技",
      name: '证件照裁剪',
      pro: '支付宝小程序'
    },
    "dingoaaiszptezz2axjy8b": {
      compony: '无锡乐骐科技有限公司',
      abridge: "乐骐科技",
      name: '最美证件照',
      pro: '钉钉小程序'
    },
    "2019042464306424": {
      compony: '无锡乐骐科技有限公司',
      abridge: "乐骐科技",
      name: '结婚证件照-骏聿',
      pro: '支付宝小程序'
    },
    "wxe1cc89066ca2855e": {
      compony: '无锡乐骐科技有限公司',
      abridge: "乐骐科技",
      name: '结婚证件照',
      pro: '微信小程序'
    },
    "wxd5b7b1624894a2ad": {
      compony: '无锡照见自己科技有限公司',
      abridge: '照见自己科技',
      name: '换装证件照',
      pro: '微信小程序'
    },
    "wx38e7fd59641f7f8d": {
      compony: '无锡照见自己科技有限公司',
      abridge: '照见自己科技',
      name: '寸照证件照',
      pro: '微信小程序'
    },
    "2021001182631392": {
      compony: '无锡照见自己科技有限公司',
      abridge: '照见自己科技',
      name: '寸照证件照',
      pro: '支付宝小程序'
    },
    "wx6cf3232a2fc3c80f": {
      compony: '无锡照见自己科技有限公司',
      abridge: '照见自己科技',
      name: '随时拍证件照',
      pro: '微信小程序'
    },
    "wx4653f4f0a121e41c": {
      compony: '无锡照见自己科技有限公司',
      abridge: '照见自己科技',
      name: '证件照随时拍',
      pro: '微信小程序'
    },
    "wxf5a0289df1400306": {
      compony: '无锡照见自己科技有限公司',
      abridge: '照见自己科技',
      name: '证件照换正装',
      pro: '微信小程序'
    },
    "wx40ebb538953c30b8": {
      compony: '无锡照见自己科技有限公司',
      abridge: '照见自己科技',
      name: 'AI智能证件照',
      pro: '微信小程序'
    },
    "wxff84012bc055388c": {
      compony: '无锡照见自己科技有限公司',
      abridge: '照见自己科技',
      name: '美丽证件照',
      pro: '微信小程序'
    },
    "17139177": {
      compony: '无锡乐骐科技有限公司',
      abridge: '乐骐科技',
      name: '乐骐结婚证件照',
      pro: '百度小程序'
    },
    "14253122":{
      compony: '无锡乐骐科技有限公司',
      abridge: '乐骐科技',
      name: '乐骐证件照在线拍摄',
      pro: '百度小程序'
    },
    "17139205": {
      compony: '无锡乐骐科技有限公司',
      abridge: '乐骐科技',
      name: '乐骐职业形象照',
      pro: '百度小程序'
    },
    "wx3e7650b86a1105fd": {
      compony: '无锡照见自己科技有限公司',
      abridge: '照见自己科技',
      name: '证件照换底',
      pro: '微信小程序'
    },
    "2021001192630596": {
      compony: '无锡乐照科技有限公司',
      abridge: '乐照科技',
      name: '证件照考试专用',
      pro: '支付宝小程序'
    },
    "0B79AC1DA237E14698C3F354B65D4036":{
      compony:'无锡乐原科技有限公司',
      abridge: '乐原科技',
      name:'最美证件照',
      pro: '京东小程序'
    },
    "2021002134618461":{
      compony:'无锡聚迪科技有限公司',
      abridge: '聚迪科技',
      name:'免费证件照',
      pro: '支付宝小程序'
    },
    "2021002160658011":{
      compony:'无锡因马科技有限公司',
      abridge: '因马科技',
      name:'漫画头像',
      pro: '支付宝小程序'
    },
    "wx2a47aabde8c567d8":{
      compony:'上海莫能臣智能科技有限公司',
      abridge: '莫能臣科技',
      name:'教师资格证件照',
      pro: '微信小程序'
    },
    "wx3a6a388af335ec6b":{
      compony:'无锡乐骐科技股份有限公司',
      abridge: '乐骐科技',
      name:'形象照研究院',
      pro: '微信小程序'
    },
    "2021002160683084":{
      compony:'无锡贝叶思思科技有限公司',
      abridge: '贝叶思思科技',
      name:'形象照研究院',
      pro: '支付宝小程序'
    }
  }
  return obj[appid]
}